export const getSortDirection = (oldDirection) => {
	if (oldDirection === 'Desc') {
		return 'Asc';
	}
	if (oldDirection === 'Asc') {
		return 'Desc';
	}
	return 'None';
};
